import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomeComponent} from './components/home/home.component';
import {AboutMeComponent} from './components/about-me/about-me.component';
import {PhotographyComponent} from './components/photography/photography.component';
import {ContactComponent} from './components/contact/contact.component';
import {WorldpageComponent} from './components/worldpage/worldpage.component';
import {ImpressumComponent} from './components/impressum/impressum.component';
import {SitemapComponent} from './components/sitemap/sitemap.component';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {ConceptionComponent} from './components/work/conception/conception.component';
import {UxdesignComponent} from './components/work/uxdesign/uxdesign.component';
import {QualityComponent} from './components/work/quality/quality.component';
import {ReferenceComponent} from './components/reference/reference.component';
import {NewscontentComponent} from './components/news/newscontent/newscontent.component';

import {PhotoComponent} from './components/photo/photo.component';
import {ProgrammingComponent} from './components/work/programming/programming.component';
import {WeatherComponent} from './components/weather/weather.component';

const routes: Routes = [
    {
        path: '',
        component: HomeComponent

    },
    {
        path: 'home',
        component: HomeComponent,
        data: {title: 'Alexander Koenig - Home'}
    },
    {
        path: 'aboutme',
        component: AboutMeComponent,
        data: {title: 'Alexander Koenig - Über mich'}
    },
    {
        path: 'aboutme/work/conception',
        component: ConceptionComponent,
        data: {title: 'Alexander Koenig - Konzeption'}
    },
    {
        path: 'aboutme/work/uxdesign',
        component: UxdesignComponent,
        data: {title: 'Alexander Koenig - UX-Design'}
    },
    {
        path: 'aboutme/work/programming',
        component: AboutMeComponent,
        data: {title: 'Alexander Koenig - Programmierung'}
    },
    {
        path: 'aboutme/work/quality',
        component: QualityComponent,
        data: {title: 'Alexander Koenig - Qualität'}
    },
    {
        path: 'references',
        component: ReferenceComponent,
        data: {title: 'Alexander Koenig - Qualität'}
    },
    {
        path: 'news/:id',
        component: NewscontentComponent,
        data: {title: 'Alexander Koenig - News'}
    },
    {
        path: 'aboutme/work/frontend',
        component: ProgrammingComponent
    },
    {
        path: 'photography',
        component: PhotographyComponent
    },

    {
        path: 'photography/:id',
        component: PhotoComponent
    },
    {
        path: 'contact',
        component: ContactComponent
    },
    {
        path: 'worldpage',
        component: WorldpageComponent
    },
    {
        path: 'impressum',
        component: ImpressumComponent
    },
    {
        path: 'sitemap',
        component: SitemapComponent
    },
    {
        path: 'weather',
        component: WeatherComponent
    },
    {path: '**', component: PageNotFoundComponent}

];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
